export default __webpack_public_path__ + "static/chunks/ui-assets/pattern-mixed-white/64c8ef63114a353d29ac4df6d7b831c6.webp";